import React, { useEffect, useState } from "react";
import api from "../../../api/axios";
import Swal from "sweetalert2";

const GenerateDocument = ({
  employeeID,
  departmentID,
  editedDocumnet,
  fetchRequestedDocument,
  documnetedData,
  setEditedDocumnet,
  documentType,
  setDocumnetType,
  isModalOpen,
  setIsModalOpen,
}) => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const data = {
    employee_id: employeeID,
    department_id: departmentID,
    document_type: documentType,
  };

  const requestSubmitHandler = async (e) => {
    setError(null);
    e.preventDefault();

    if (editedDocumnet?.requested_id) {
      setIsLoading(true);
      try {
        const document = documentType
          ? documentType
          : editedDocumnet?.requested_document;
        console.log("resposne", document);
        const resposne = await api.put(
          `hr/update-requested-documnet/${editedDocumnet?.employee_id}/${editedDocumnet?.requested_id}`,
          { document }
        );
        console.log("resposne", resposne);
        if (resposne?.data?.success == true) {
          Swal.fire("success", "Document Updated Successfully", "success");
          fetchRequestedDocument();
          setDocumnetType("");
          setEditedDocumnet({});
          closeModal();
        }
      } catch (err) {
        Swal.fire("error", "Error in  Update  Document", "error");
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(true);
      try {
        const response = await api.post(`hr/document-request`, data);
        if (response?.data?.success === true) {
          console.log("working....");
          Swal.fire("success", "Document Requested Successfully", "success");
          fetchRequestedDocument();
          setDocumnetType("");
          setEditedDocumnet({});
          closeModal();
        } else {
          console.log(response?.data?.error);
        }
      } catch (error) {
        Swal.fire("error", "Error in  Submitting Document Request", "error");
        if (
          error?.response?.data?.success === false &&
          error?.response?.data?.error_code == "E001"
        ) {
          setError(error?.response?.data?.error);
        }
      } finally {
        setIsLoading(false);
      }
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setError(null);
    setDocumnetType("");
    setEditedDocumnet({});
    const dropDown = document.getElementById("document_dropdown");
    dropDown.value = "";
  };

  return (
    <>
      <div
        id="generate_document"
        className={`modal custom-modal fade ${
          isModalOpen ? "show d-block" : ""
        }`}
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Request Document</h5>
              <button type="button" className="btn-close" onClick={closeModal}>
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={requestSubmitHandler}>
                <div className="input-block mb-5">
                  <label className="col-form-label">Select Document</label>
                  <div
                    className="select-container "
                    style={{ maxHeight: "50px", overflowY: "auto" }}
                  >
                    <select
                      className="form-control"
                      required
                      placeholder="Select"
                      name="hr_document"
                      id="document_dropdown"
                      value={
                        documentType
                          ? documentType
                          : editedDocumnet?.requested_document
                      }
                      onChange={(e) => setDocumnetType(e.target.value)}
                    >
                      <option value="">Select document</option>
                      {documnetedData?.map((item) => (
                        <option
                          key={item.id}
                          data-id={item.id}
                          value={item?.id}
                        >
                          {item.value}
                        </option>
                      ))}
                    </select>
                  </div>
                  {error && (
                    <span style={{ color: "red", fontSize: "14px" }}>
                      * {error}
                    </span>
                  )}
                </div>

                {/* <div className="submit-section " style={{borderTop:"2px solid red"}}>
                  <button
                    className="btn btn-primary submit-btn"
                    data-bs-dismiss="modal"
                    // aria-label={closeModal&&"Close"}
                    type="submit"
                  >
                    Request
                  </button>
                </div> */}
                <div
                  className="row mt-5"
                  style={{ borderTop: "2px solid #d5d9e0" }}
                >
                  <div className="col-lg-12 text-end form-wizard-button mt-3">
                    <button
                      className="btn btn-primary submit-btn"
                      type="submit"
                      disabled={documentType || !isLoading ? false : true}
                    >
                      {isLoading ? "Requesting..." : "Request"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GenerateDocument;
